import { Box } from '@mui/material';
import { HeaderComponent } from '../shared/HeaderComponent';
import { RewardHistory } from './RewardHistory';
import { useState } from 'react';
import { BannerComponent } from '../shared/BannerComponent';

export const Rewards = () => {
    const [hideTable, setHideTable] = useState(false);
    const switchTable = () => {
        setHideTable(!hideTable);
    };
    return (
        <Box sx={{ height: '1184px', overflow: 'hidden' }}>
            <HeaderComponent title="Bitcoin Rewards" />
            <BannerComponent />
            <RewardHistory ceroPoints={hideTable} switchTable={switchTable} />
        </Box>
    );
};
